// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gurdurr: PokeData = {
  "id": 533,
  "name": "gurdurr",
  "height": 12,
  "weight": 400,
  "base_experience": 142,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "pound",
    "slam",
    "leer",
    "low-kick",
    "rock-throw",
    "focus-energy",
    "bide",
    "rock-slide",
    "scary-face",
    "dynamic-punch",
    "focus-punch",
    "superpower",
    "bulk-up",
    "wake-up-slap",
    "hammer-arm",
    "stone-edge",
    "chip-away"
  ],
  "moves": [
    "leer",
    "rock-throw",
    "rock-slide",
    "scary-face",
    "superpower",
    "bulk-up",
    "rolling-kick",
    "karate-chop",
    "vacuum-wave",
    "close-combat",
    "jump-kick",
    "drain-punch",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 272,
    "item": null,
    "species": [
      {
        "name": "timburr",
        "order": 533,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gurdurr",
        "order": 534,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 532,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "conkeldurr",
        "order": 535,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 533,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 76.25,
    "speed": 40,
    "ability_power": 105
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
